import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=ba06f6ce&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=ba06f6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba06f6ce",
  null
  
)

export default component.exports